<app-mini-layout-wrapper [showLogout]="true">
  <div class="mini-layout__title">{{ texts.title }}</div>
  <div class="mini-layout__text">{{ texts.additionalText }}</div>
</app-mini-layout-wrapper>
